import React, { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';

const CollapsibleCodeExecution: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { colors } = useTheme();

  return (
    <div style={{ margin: '8px 0' }}>
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          background: 'none',
          border: `1px solid ${colors.border}`,
          borderRadius: isExpanded ? '6px 6px 0 0' : '6px',
          padding: '8px 12px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: 'bold',
          color: colors.primary,
          backgroundColor: colors.surfaceElevated,
          width: '100%',
          justifyContent: 'flex-start',
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = colors.buttonHover;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = colors.surfaceElevated;
        }}
      >
        <span>Code Execution</span>
        <span style={{
          marginLeft: 'auto',
          fontSize: '12px',
          transition: 'transform 0.2s ease',
          transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'
        }}>
          ▶
        </span>
      </button>

      {isExpanded && (
        <div style={{
          border: `1px solid ${colors.border}`,
          borderTop: 'none',
          borderRadius: '0 0 6px 6px',
          overflow: 'hidden'
        }}>
          {React.cloneElement(children as React.ReactElement, {
            noMargin: true
          })}
        </div>
      )}
    </div>
  );
};

export default CollapsibleCodeExecution;